import { Currency } from '@/core/currency/interfaces';

const AWG: Currency = {
    name: 'Aruban Florin',
    demonym: 'Aruban',
    majorSingle: 'Florin',
    majorPlural: 'Florin',
    codeNumeric: '533',
    symbol: 'ƒ',
    symbolNative: 'ƒ',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AWG',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AWG;
